webpackJsonp([1],{

/***/ "+bOk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+fg7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+g7E":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vuex = __webpack_require__("NYxO");

var _firebase = __webpack_require__("Sazm");

var _firebase2 = _interopRequireDefault(_firebase);

var _sweetalert = __webpack_require__("e7x4");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      allUsers: null
    };
  },

  name: 'adminUser',
  computed: _extends({}, (0, _vuex.mapState)(['userAuth', 'userCred'])),
  created: function created() {
    this.loadUsers();
  },

  methods: _extends({}, (0, _vuex.mapMutations)(['fbLogin', 'gitLogin', 'logout']), {
    loadUsers: function loadUsers() {
      var this_ = this;
      _firebase2.default.database().ref('users/').once('value').then(function (snapshot) {
        // for (var i in snapshot.val()) {
        this_.allUsers = snapshot.val();
        // }
      });
    },
    userRemove: function userRemove(id) {
      var this_ = this;
      (0, _sweetalert2.default)({
        title: 'Remove User',
        text: 'คุณต้องการลบผู้ใช้นี้จริงๆหรือไม่?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes!'
      }).then(function (result) {
        if (result.value) {
          _firebase2.default.database().ref('/users').orderByChild('createdAt').equalTo(id).once('value').then(function (snapshot) {
            snapshot.forEach(function (childSnapshot) {
              _firebase2.default.database().ref('/users').child(childSnapshot.key).remove().then(function () {
                (0, _sweetalert2.default)("Remove Task", "คุณได้ลบ User", "success");
                this_.loadUsers();
              });
            });
          });
        }
      });
    }
  })
};

/***/ }),

/***/ "/g2R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar navbar-expand-md fixed-top"},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_c('img',{staticStyle:{"height":"40px"},attrs:{"src":__webpack_require__("aaIl")}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navbarSupportedContent"}},[_c('ul',{staticClass:"navbar-nav mr-auto"},[_c('li',{staticClass:"nav-item sm"},[(_vm.userData)?_c('div',{staticClass:"nav-profile",staticStyle:{"border-radius":"2px","margin-top":"5px","color":"#DFDCE3","font-size":"22px"}},[_c('strong',[_vm._v(_vm._s(_vm.userAuth.displayName))])]):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"nav-item sm"},[(_vm.userData)?_c('div',{staticClass:"nav-point",staticStyle:{"border-radius":"2px","margin-top":"5px"}},[_c('span',[_c('img',{staticStyle:{"width":"25px","border-radius":"50%","padding-bottom":"4px"},attrs:{"src":__webpack_require__("twqq")}}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.userData.point))])])]):_vm._e(),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'scoreboard'}}},[_c('strong',{class:{ 'disabled': !_vm.userAuth }},[_c('i',{staticClass:"fa fa-star",attrs:{"aria-hidden":"true"}}),_vm._v(" SCORE BOARD")])])],1),_vm._v(" "),_c('li',{staticClass:"nav-item sm"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'index'}}},[_c('strong',{class:{ 'disabled': !_vm.userAuth }},[_vm._v(" OPTION")])])],1),_vm._v(" "),(_vm.userData && _vm.userData.permission > 2)?_c('li',{staticClass:"nav-item sm"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'adminTask'}}},[_c('strong',[_c('i',{staticClass:"fa fa-star",attrs:{"aria-hidden":"true"}}),_vm._v(" ADMIN")])])],1):_vm._e(),_vm._v(" "),(_vm.userData)?_c('li',{staticClass:"nav-item sm"},[_c('hr'),_vm._v(" "),_c('a',{staticClass:"nav-link",staticStyle:{"cursor":"pointer"},on:{"click":_vm.logout}},[_c('strong',[_vm._v("SIGN OUT")])])]):_c('li',{staticClass:"nav-item sm"},[_c('hr'),_vm._v(" "),_c('a',{staticClass:"nav-link",staticStyle:{"cursor":"pointer"},on:{"click":_vm.fbLogin}},[_c('strong',[_vm._v("SIGN IN")])])])]),_vm._v(" "),(_vm.userData)?_c('ul',{staticClass:"form-inline my-2 my-lg-0"},[_c('li',{staticClass:"nav-item md"},[_c('a',{staticClass:"nav-link"},[_c('div',{staticClass:"nav-point"},[_c('img',{staticStyle:{"width":"38px","border-radius":"50%"},attrs:{"src":__webpack_require__("twqq")}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.userData.point))])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item dropdown md"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#","id":"profile-dropdown","data-toggle":"dropdown","aria-haspopup":"false","aria-expanded":"false"}},[_c('div',{staticClass:"nav-profile"},[_c('img',{staticStyle:{"width":"38px","border-radius":"50%"},attrs:{"src":_vm.userData.image}}),_vm._v(" "),_c('i',{staticClass:"fa fa-chevron-down",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right",attrs:{"aria-labelledby":"profile-dropdown"}},[_c('span',{staticClass:"dropdown-header"},[_c('strong',[_vm._v(" "+_vm._s(_vm.userAuth.displayName)+" ")])]),_vm._v(" "),_c('div',{staticClass:"dropdown-divider"}),_vm._v(" "),_c('span',{staticClass:"dropdown-item"},[_c('div',{staticClass:"nav-point"},[_c('span',[_c('img',{staticStyle:{"width":"25px","border-radius":"50%","padding-bottom":"4px"},attrs:{"src":__webpack_require__("twqq")}}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.userData.point))])])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-divider"}),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("OPTION")]),_vm._v(" "),(_vm.userData.permission > 2)?_c('router-link',{staticClass:"dropdown-item",attrs:{"to":{ name: 'adminTask'}}},[_vm._v("ADMIN")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dropdown-divider"}),_vm._v(" "),_c('a',{staticClass:"dropdown-item",staticStyle:{"cursor":"pointer"},on:{"click":_vm.logout}},[_vm._v("SIGN OUT")])],1)])]):_c('ul',{staticClass:"form-inline my-2 my-lg-0 md"},[_vm._m(1),_vm._v(" "),_c('li',{staticClass:"nav-item dropdown"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right",attrs:{"aria-labelledby":"profile-dropdown"}},[_c('a',{staticClass:"dropdown-item",staticStyle:{"cursor":"pointer"},on:{"click":_vm.fbLogin}},[_vm._v("SIGN IN FB")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",staticStyle:{"cursor":"pointer"},on:{"click":_vm.gitLogin}},[_vm._v("SIGN IN GIT")])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggler",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navbarSupportedContent","aria-controls":"navbarSupportedContent","aria-expanded":"false","aria-label":"Toggle navigation"}},[_c('i',{staticClass:"fa fa-bars",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item disabled"},[_c('a',{staticClass:"nav-link"},[_c('div',{staticClass:"nav-point"},[_c('img',{staticStyle:{"width":"38px","border-radius":"50%"},attrs:{"src":__webpack_require__("twqq")}}),_vm._v(" "),_c('span',[_vm._v("0")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-link",attrs:{"id":"profile-dropdown","data-toggle":"dropdown","aria-haspopup":"false","aria-expanded":"false"}},[_c('div',{staticClass:"nav-profile"},[_c('img',{staticStyle:{"width":"38px","border-radius":"50%"},attrs:{"src":__webpack_require__("TlOy")}}),_vm._v(" "),_c('i',{staticClass:"fa fa-chevron-down",attrs:{"aria-hidden":"true"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/y1X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var firebaseConfig = exports.firebaseConfig = {
    apiKey: "AIzaSyCYZITY896y1KRSv85i9di_kceXJdigU8I",
    authDomain: "longcode-897ac.firebaseapp.com",
    databaseURL: "https://longcode-897ac.firebaseio.com",
    projectId: "longcode-897ac",
    storageBucket: "longcode-897ac.appspot.com",
    messagingSenderId: "500573545226"
};

/***/ }),

/***/ "0lyJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.taskData)?_c('div',{staticClass:"task-container"},[_c('div',{staticClass:"practiceTask row"},[_c('div',{staticClass:"taskDetail col-lg text-left"},[_c('div',{staticClass:"detail-nav"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4 text-left"},[_c('router-link',{staticClass:"code-icon-backword",attrs:{"to":{ name: 'practice' }}},[_c('i',{staticClass:"fa fa-backward",attrs:{"aria-hidden":"true"}}),_vm._v(" Back\n            ")])],1),_vm._v(" "),_c('div',{staticClass:"col-8 text-right"},[_vm._v("\n            ||\n            "),_c('strong',[_vm._v(_vm._s(_vm.taskData.name))]),_vm._v(" ||\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"detail-body pt-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"text-center"},[_c('h4',[_c('strong',[_vm._v(_vm._s(_vm.taskData.name))])])]),_vm._v(" "),_c('hr',{staticStyle:{"border-color":"#D94B3F"}}),_vm._v(" "),_c('div',{staticStyle:{"word-break":"break-all","letter-spacing":"0.5px"}},[_c('strong',[_vm._v("Description:")]),_vm._v(" "),_c('div',{staticStyle:{"background":"#e6e6e6","border-radius":"3px"}},[_c('p',{staticStyle:{"text-indent":"10px","padding":"5px","white-space":"pre-wrap"}},[_vm._v(_vm._s(_vm.taskData.detail))])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"margin-bottom":"10px"}},[_c('strong',[_vm._v("Difficulty:")]),_vm._v(" "),_c('span',{staticStyle:{"color":"#4b4257"}},[_vm._v(_vm._s(_vm.difficulty))])]),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"10px"}},[_c('strong',[_vm._v("Reward:")]),_vm._v(" "),_c('span',{staticStyle:{"color":"#4b4257"}},[_vm._v(_vm._s(_vm.point))]),_vm._v(" "),_c('img',{staticStyle:{"width":"25px","border-radius":"50%","padding-bottom":"4px"},attrs:{"src":__webpack_require__("twqq")}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('strong',[_vm._v("Input:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("\n                  Main Function:\n                  "),_c('strong',{staticStyle:{"color":"#4b4257","background":"#e6e6e6","padding":"2px 5px"}},[_vm._v(_vm._s(_vm.functionName))])]),_vm._v(" "),_c('li',[_vm._v("\n                  Argument:\n                  "),_c('strong',{staticStyle:{"color":"#4b4257","background":"#e6e6e6","padding":"2px 5px"}},[_vm._v(_vm._s(_vm.argName))])]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_vm._m(1),_vm._v(" "),_vm._l((_vm.taskData.testcase),function(testcase,count){return _c('div',[_c('div',{staticClass:"testcase-header",staticStyle:{"cursor":"pointer"},attrs:{"width":"75%","data-toggle":"collapse","data-target":'#' + _vm.taskData.createdAt + '-' + count,"aria-expanded":"false"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm"},[_vm._v("Case "+_vm._s(count+1))]),_vm._v(" "),_c('div',{staticClass:"col-sm text-right mr-2"},[(Math.round(_vm.taskLength / 2) <= count)?_c('span',[_c('i',{staticClass:"fa fa-lock",attrs:{"aria-hidden":"true"}})]):_vm._e()])])]),_vm._v(" "),(count < Math.round(_vm.taskLength / 2))?_c('div',{staticClass:"collapse testcase-body",attrs:{"id":_vm.taskData.createdAt + '-' + count}},[_c('ul',[_c('li',_vm._l((testcase.input[0]),function(x){return _c('span',[_vm._v("\n                        Input:\n                        "),_c('strong',{staticStyle:{"color":"#4b4257","background":"#e6e6e6"}},_vm._l((testcase.input),function(inputs){return _c('span',_vm._l((inputs),function(value,key){return _c('div',{staticStyle:{"padding":"0"}},[_vm._v("\n                              - "+_vm._s(key)+":\n                              "),_c('strong',{staticStyle:{"color":"#4b4257","background":"#e6e6e6","padding":"2px 5px"}},[_vm._v(_vm._s(value))])])}),0)}),0),_vm._v(" "),_c('br')])}),0),_vm._v(" "),_c('li',[_vm._v("\n                      Output:\n                      "),_c('strong',{staticStyle:{"color":"#4b4257","background":"#e6e6e6","padding":"2px 5px"}},[_vm._v(_vm._s(testcase.output))])])])]):_vm._e()])})],2),_vm._v(" "),_c('br'),_vm._v(" "),_c('hr',{staticStyle:{"border-color":"#D94B3F"}}),_vm._v(" "),_c('br')])])])]),_vm._v(" "),_c('div',{staticClass:"taskCode col-lg text-left"},[_c('div',{staticClass:"code-nav"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4 text-left"},[_c('span',{attrs:{"id":"code-icon-reset"},on:{"click":_vm.taskLoad}},[_c('i',{staticClass:"fa fa-refresh",attrs:{"aria-hidden":"true"}}),_vm._v(" Reset\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-8 text-right"},[_c('button',{staticClass:"btn btn-danger bg-salmon-1 pointer btn-sm",staticStyle:{"padding":"0px 10px"},on:{"click":_vm.taskSubmit}},[_vm._v("SUBMIT")])])])]),_vm._v(" "),_c('div',{staticClass:"row code-container",staticStyle:{"margin":"0"}},[_c('div',{staticClass:"col",staticStyle:{"padding":"0"}},[_c('codemirror',{attrs:{"options":_vm.editorOption,"id":"code-mirror"},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}})],1)])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_vm._v("\n                  Time Limit:\n                  "),_c('strong',{staticStyle:{"color":"#4b4257","background":"#e6e6e6","padding":"2px 5px"}},[_vm._v("1000ms")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-bottom":"10px"}},[_c('strong',[_vm._v("Testcase:")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0n/o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userAuth && _vm.userData && _vm.userEnroll)?_c('div',[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"practice col-md-11 col-lg-9"},[_vm._m(0),_vm._v(" "),_c('hr',{staticStyle:{"border-color":"#EAC67A"}}),_vm._v(" "),_vm._l((_vm.practiceList),function(task){return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('router-link',{attrs:{"to":'/practice/' + task.createdAt}},[_c('div',{staticClass:"card task-practice",class:{'taskPass': _vm.taskPass.indexOf(task.createdAt + '') >= 0}},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-lg-8 text-left"},[_c('strong',[_vm._v(_vm._s(task.name)+" "),(_vm.taskPass.indexOf(task.createdAt + '') >= 0)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"#009933"},attrs:{"aria-hidden":"true"}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col col-lg-4 text-right"},[_vm._v("\n                  "+_vm._s(Math.round((task.send / task.pass * 60) / 10) * 10)+" "),_c('img',{staticStyle:{"width":"25px","border-radius":"50%"},attrs:{"src":__webpack_require__("twqq")}})])])])])])],1)])}),_vm._v(" "),_c('br'),_c('br'),_c('hr',{staticStyle:{"border-color":"#D94B3F"}})],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left"},[_c('strong',{staticStyle:{"color":"#233237"}},[_vm._v("PRACTICE TASKS")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0tbE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1XTk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2b9r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4/hK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "54i7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("Aracde")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7+bd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aracde_vue__ = __webpack_require__("pgdX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aracde_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aracde_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aracde_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aracde_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5372da6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aracde_vue__ = __webpack_require__("54i7");
function injectStyle (ssrContext) {
  __webpack_require__("iI97")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aracde_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5372da6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aracde_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "7HYY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7nVR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userAuth && _vm.userData && _vm.scoreBest.length > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"scoreboard col-lg-9 col-md-11 col-sm-11 col-xs-11 mx-auto"},[_c('div',{staticClass:"scoreboard-best text-left"},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row text-center"},[_c('transition',{attrs:{"name":"leader-box1-load"}},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card scoreboard-box-first"},[_c('div',{staticClass:"card-header"},[_c('strong',[_vm._v("1st PLACE "),_c('span',{staticStyle:{"color":"#EAC67A"}},[_c('i',{staticClass:"fa fa-trophy",attrs:{"aria-hidden":"true"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-block"},[_c('div',{staticStyle:{"padding":"10px"}},[_c('img',{staticStyle:{"width":"30%","border-radius":"50%","border":"5px solid #18121E"},attrs:{"src":_vm.scoreBest[0].image}})]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("TOTAL POINT :")]),_vm._v(" "),_c('strong',{staticStyle:{"color":"#EAC67A"}},[_vm._v(_vm._s(_vm.scoreBest[0].point))])]),_vm._v(" "),_c('hr',{staticStyle:{"border-color":"#f2f2f2"}}),_vm._v(" "),_c('div',{staticStyle:{"padding-bottom":"10px"}},[_c('strong',{staticStyle:{"color":"#DFDCE3","font-size":"15px"}},[_vm._v(_vm._s(_vm.scoreBest[0].name))])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card scoreboard-box-second"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-block"},[_c('div',{staticStyle:{"padding":"10px"}},[_c('img',{staticStyle:{"width":"30%","border-radius":"50%","border":"5px solid #18121E"},attrs:{"src":_vm.scoreBest[1].image}})]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("TOTAL POINT :")]),_vm._v(" "),_c('strong',{staticStyle:{"color":"#EAC67A"}},[_vm._v(_vm._s(_vm.scoreBest[1].point))])]),_vm._v(" "),_c('hr',{staticStyle:{"border-color":"#f2f2f2"}}),_vm._v(" "),_c('div',{staticStyle:{"padding-bottom":"10px"}},[_c('strong',{staticStyle:{"color":"#DFDCE3","font-size":"15px"}},[_vm._v(_vm._s(_vm.scoreBest[1].name))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card scoreboard-box-third"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"card-block"},[_c('div',{staticStyle:{"padding":"10px"}},[_c('img',{staticStyle:{"width":"30%","border-radius":"50%","border":"5px solid #18121E"},attrs:{"src":_vm.scoreBest[2].image}})]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("TOTAL POINT :")]),_vm._v(" "),_c('strong',{staticStyle:{"color":"#EAC67A"}},[_vm._v(_vm._s(_vm.scoreBest[2].point))])]),_vm._v(" "),_c('hr',{staticStyle:{"border-color":"#f2f2f2"}}),_vm._v(" "),_c('div',{staticStyle:{"padding-bottom":"10px"}},[_c('strong',{staticStyle:{"color":"#DFDCE3","font-size":"15px"}},[_vm._v(_vm._s(_vm.scoreBest[2].name))])])])])])],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"scoreboard-table text-left"},[_vm._m(3),_c('br'),_c('br'),_vm._v(" "),_c('table',{staticClass:"table"},[_vm._m(4),_vm._v(" "),_c('tbody',_vm._l((_vm.scoreBest),function(score,key){return _c('tr',[_c('td',{attrs:{"width":"10%"}},[_vm._v(_vm._s(key+1))]),_vm._v(" "),_c('td',{attrs:{"width":"80%"}},[_c('img',{staticStyle:{"width":"40px","border-radius":"50%","padding-right":"5px"},attrs:{"src":score.image}}),_vm._v(" "+_vm._s(score.name))]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v(_vm._s(score.point))])])}),0)])]),_vm._v(" "),_c('hr'),_c('br')])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('strong',{staticStyle:{"color":"#233237"}},[_vm._v("TOP 3 USER")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('strong',[_vm._v("2st PLACE")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('strong',[_vm._v("3st PLACE")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('strong',{staticStyle:{"color":"#233237"}},[_vm._v("LEADER BOARD")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"width":"10%"}},[_vm._v("#")]),_vm._v(" "),_c('th',{attrs:{"width":"80%"}},[_vm._v("User")]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("Point")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8HjM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-user"},[_c('table',{staticClass:"table",staticStyle:{"clear":"both"}},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.allUsers),function(user,num,num2){return _c('tr',[_c('td',{attrs:{"width":"10%"}},[_vm._v(_vm._s(num2+1))]),_vm._v(" "),_c('td',{staticStyle:{"cursor":"pointer"},attrs:{"width":"75%","data-toggle":"collapse","data-target":'#' + user.createdAt,"aria-expanded":"false","aria-controls":"#admin-task-view"}},[_c('div',[_c('strong',[_vm._v(_vm._s(user.name))])]),_vm._v(" "),_c('div',{staticClass:"collapse",attrs:{"id":user.createdAt}},[_c('hr',{staticStyle:{"border":"0.5px solid #ccc","margin":"10px 0"}}),_vm._v(" "),_c('span',{staticClass:"mt-1",staticStyle:{"color":"#595959"}},[_vm._v("Email: ")]),_c('span',[_vm._v(_vm._s(user.email))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"mt-1",staticStyle:{"color":"#595959"}},[_vm._v("Permission: ")]),_c('span',[_vm._v(_vm._s(user.permission))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"mt-1",staticStyle:{"color":"#595959"}},[_vm._v("Created At: ")]),_c('span',[_vm._v(_vm._s(user.createdAt))]),_c('br'),_vm._v(" "),_c('hr',{staticStyle:{"border":"0.5px solid #ccc","margin":"10px 0"}})])]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"width":"15%"}},[_c('a',{staticStyle:{"color":"#D94B3F","cursor":"pointer"},on:{"click":function($event){return _vm.userRemove(user.createdAt)}}},[_c('i',{staticClass:"fa fa-2x fa-times",attrs:{"aria-hidden":"true"}})])])])}),0)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('br')])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"width":"10%"}},[_vm._v("#")]),_vm._v(" "),_c('th',{attrs:{"width":"75%"}},[_vm._v("NAME")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("DELETE")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8sIG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("MyTask Page")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8sUU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9ozf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AnfX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BCHN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BEHr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PracticeTask_vue__ = __webpack_require__("oabq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PracticeTask_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PracticeTask_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PracticeTask_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PracticeTask_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4adb90c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PracticeTask_vue__ = __webpack_require__("0lyJ");
function injectStyle (ssrContext) {
  __webpack_require__("7HYY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PracticeTask_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4adb90c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PracticeTask_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "BEen":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_codemirror_vue__ = __webpack_require__("BJxZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_codemirror_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_codemirror_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_codemirror_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_codemirror_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_10957dea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_codemirror_vue__ = __webpack_require__("l1ch");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_codemirror_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_10957dea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_codemirror_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "BJxZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//

window.CodeMirror = __webpack_require__("8U58");
__webpack_require__("4/hK");
__webpack_require__("+fCR");
exports.default = {
  name: 'codemirror',
  data: function data() {
    return {
      content: ''
    };
  },
  props: {
    code: String,
    value: String,
    events: Array,
    unseenLines: Array,
    marker: Function,
    loadtheme: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    debugger: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    options: {
      type: Object,
      required: true
    }
  },
  created: function created() {

    if (this.options.lineNumbers === undefined) {
      this.options.lineNumbers = true;
    }
    if (this.options.lineWrapping === undefined) {
      this.options.lineWrapping = false;
    }
    if (this.options.mode === undefined) {
      this.options.mode = 'text/javascript';
    }

    var theme = this.options.theme;
    var language = this.options.mode;
    var _debugger = this.debugger;
    var _loadtheme = this.loadtheme;
    var isCustomMode = !!CodeMirror.modes[language];

    // theme config
    if (theme && theme == 'solarized light') {
      theme = 'solarized';
    }

    // console.log(language, CodeMirror.modes.simplemode)

    // language string config
    if (typeof language == 'string') {
      var lang = CodeMirror.findModeByMIME(language);
      language = !lang ? lang : lang.mode;

      // language object config
    } else if ((typeof language === 'undefined' ? 'undefined' : _typeof(language)) == 'object') {

      if (language.name) {
        var lang = CodeMirror.findModeByName(language.name);
        if (lang) {
          language = lang.mode;
          // this.options.mode = language
        } else {
          language = null;
        }
      } else if (language.ext) {
        var lang = CodeMirror.findModeByExtension(language.ext);
        if (lang) {
          language = lang.mode;
          // this.options.mode = language
        } else {
          language = null;
        }
      } else if (language.mime) {
        var lang = CodeMirror.findModeByMIME(language.mime);
        if (lang) {
          language = lang.mode;
          // this.options.mode = language
        } else {
          language = null;
        }
      } else if (language.filename) {
        var lang = CodeMirror.findModeByFileName(language.filename);
        if (lang) {
          language = lang.mode;
          // this.options.mode = language
        } else {
          language = null;
        }
      }
    }

    // console.log('language', language, isCustomMode)

    if ((!language || language == 'null') && _debugger && !isCustomMode) {
      console.warn('CodeMirror language mode: ' + language + ' configuration error (CodeMirror语言模式配置错误，或者不支持此语言) See http://codemirror.net/mode/ for more details.');
      // return false
    }

    // console.log(language, theme)

    // require language
    if (language && language !== 'null') {
      __webpack_require__("ENpB")("./" + language + '/' + language + '.js');
    }

    // require theme
    if (theme && _loadtheme) {
      __webpack_require__("aHkt")("./" + theme + '.css');
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.editor = CodeMirror.fromTextArea(this.$el, this.options);
    this.editor.setValue(this.code || this.value || this.content);
    this.editor.on('change', function (cm) {
      _this.content = cm.getValue();
      if (!!_this.$emit) {
        _this.$emit('change', _this.content);
        _this.$emit('input', _this.content);
      }
    });
    var events = ['scroll', 'changes', 'beforeChange', 'cursorActivity', 'keyHandled', 'inputRead', 'electricInput', 'beforeSelectionChange', 'viewportChange', 'swapDoc', 'gutterClick', 'gutterContextMenu', 'focus', 'blur', 'refresh', 'optionChange', 'scrollCursorIntoView', 'update'];
    if (this.events && this.events.length) {
      events = events.concat(this.events);
    }
    for (var i = 0; i < events.length; i++) {
      if (events.indexOf(events[i]) == i) {
        (function (event) {
          _this.editor.on(event, function (a, b, c) {
            _this.$emit(event, a, b, c);
          });
        })(events[i]);
      }
    }
    this.$emit('ready', this.editor);
    this.unseenLineMarkers();

    // prevents funky dynamic rendering
    window.setTimeout(function () {
      _this.editor.refresh();
    }, 0);
  },
  beforeDestroy: function beforeDestroy() {

    // garbage cleanup
    var element = this.editor.doc.cm.getWrapperElement();
    if (element && element.remove) {
      element.remove();
    }
  },
  watch: {
    options: {
      deep: true,
      handler: function handler(options, oldOptions) {
        var key;
        for (key in options) {
          this.editor.setOption(key, options[key]);
        }
      }
    },
    code: function code(newVal, oldVal) {
      var editor_value = this.editor.getValue();
      if (newVal !== editor_value) {
        var scrollInfo = this.editor.getScrollInfo();
        this.editor.setValue(newVal);
        this.content = newVal;
        this.editor.scrollTo(scrollInfo.left, scrollInfo.top);
      }
      this.unseenLineMarkers();
    },
    value: function value(newVal, oldVal) {
      var editor_value = this.editor.getValue();
      if (newVal !== editor_value) {
        var scrollInfo = this.editor.getScrollInfo();
        this.editor.setValue(newVal);
        this.content = newVal;
        this.editor.scrollTo(scrollInfo.left, scrollInfo.top);
      }
      this.unseenLineMarkers();
    }
  },
  methods: {
    refresh: function refresh() {
      this.editor.refresh();
    },
    unseenLineMarkers: function unseenLineMarkers() {
      var _this = this;
      if (_this.unseenLines !== undefined && _this.marker !== undefined) {
        _this.unseenLines.forEach(function (line) {
          var info = _this.editor.lineInfo(line);
          _this.editor.setGutterMarker(line, "breakpoints", info.gutterMarkers ? null : _this.marker());
        });
      }
    }
  }
};

/***/ }),

/***/ "BR0Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CIEy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D1hx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Challenges_vue__ = __webpack_require__("gMtO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Challenges_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Challenges_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Challenges_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Challenges_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19dd7dc9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Challenges_vue__ = __webpack_require__("fViY");
function injectStyle (ssrContext) {
  __webpack_require__("T8qm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Challenges_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19dd7dc9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Challenges_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ENpB":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./apl/apl.js": "qxza",
	"./asciiarmor/asciiarmor.js": "fKDv",
	"./asn.1/asn.1.js": "P89j",
	"./asterisk/asterisk.js": "5YCJ",
	"./brainfuck/brainfuck.js": "77wO",
	"./clike/clike.js": "6S2o",
	"./clojure/clojure.js": "1J1+",
	"./cmake/cmake.js": "3l40",
	"./cobol/cobol.js": "SHcL",
	"./coffeescript/coffeescript.js": "yI/k",
	"./commonlisp/commonlisp.js": "+T+e",
	"./crystal/crystal.js": "Id8r",
	"./css/css.js": "puAj",
	"./cypher/cypher.js": "To3j",
	"./d/d.js": "zdi2",
	"./dart/dart.js": "T43g",
	"./diff/diff.js": "HDE3",
	"./django/django.js": "B5Q8",
	"./dockerfile/dockerfile.js": "bNms",
	"./dtd/dtd.js": "Vcha",
	"./dylan/dylan.js": "V3et",
	"./ebnf/ebnf.js": "+yUg",
	"./ecl/ecl.js": "yP40",
	"./eiffel/eiffel.js": "kaWT",
	"./elm/elm.js": "gO0v",
	"./erlang/erlang.js": "KyD5",
	"./factor/factor.js": "ZZxW",
	"./fcl/fcl.js": "VmZn",
	"./forth/forth.js": "OEOO",
	"./fortran/fortran.js": "SUHZ",
	"./gas/gas.js": "DVrE",
	"./gfm/gfm.js": "bWRU",
	"./gherkin/gherkin.js": "BGqB",
	"./go/go.js": "CQVp",
	"./groovy/groovy.js": "lYxz",
	"./haml/haml.js": "kDpU",
	"./handlebars/handlebars.js": "Qei9",
	"./haskell-literate/haskell-literate.js": "TUpE",
	"./haskell/haskell.js": "ao9a",
	"./haxe/haxe.js": "T0xp",
	"./htmlembedded/htmlembedded.js": "zA3a",
	"./htmlmixed/htmlmixed.js": "8Nur",
	"./http/http.js": "Ssj+",
	"./idl/idl.js": "s5ks",
	"./javascript/javascript.js": "5IAE",
	"./jinja2/jinja2.js": "3h7H",
	"./jsx/jsx.js": "KR8v",
	"./julia/julia.js": "uRaj",
	"./livescript/livescript.js": "SEST",
	"./lua/lua.js": "SN96",
	"./markdown/markdown.js": "f6fj",
	"./mathematica/mathematica.js": "BPpj",
	"./mbox/mbox.js": "g3M4",
	"./meta.js": "+fCR",
	"./mirc/mirc.js": "nngO",
	"./mllike/mllike.js": "YJVH",
	"./modelica/modelica.js": "tbda",
	"./mscgen/mscgen.js": "O099",
	"./mumps/mumps.js": "MIy+",
	"./nginx/nginx.js": "fQr+",
	"./nsis/nsis.js": "qp6r",
	"./ntriples/ntriples.js": "Aju4",
	"./octave/octave.js": "JPpr",
	"./oz/oz.js": "/8wJ",
	"./pascal/pascal.js": "MXNw",
	"./pegjs/pegjs.js": "MJwH",
	"./perl/perl.js": "rQCa",
	"./php/php.js": "c6RA",
	"./pig/pig.js": "AnxN",
	"./powershell/powershell.js": "n04a",
	"./properties/properties.js": "0nxQ",
	"./protobuf/protobuf.js": "UHRe",
	"./pug/pug.js": "PdD+",
	"./puppet/puppet.js": "11SB",
	"./python/python.js": "tWbI",
	"./q/q.js": "LE4k",
	"./r/r.js": "9BoL",
	"./rpm/rpm.js": "QGGy",
	"./rst/rst.js": "A2n/",
	"./ruby/ruby.js": "uOPQ",
	"./rust/rust.js": "9NDn",
	"./sas/sas.js": "uQEz",
	"./sass/sass.js": "7BQ2",
	"./scheme/scheme.js": "l6KL",
	"./shell/shell.js": "PG9i",
	"./sieve/sieve.js": "T01z",
	"./slim/slim.js": "M/P5",
	"./smalltalk/smalltalk.js": "IQG/",
	"./smarty/smarty.js": "qFPF",
	"./solr/solr.js": "Gz0W",
	"./soy/soy.js": "d4f2",
	"./sparql/sparql.js": "0hjm",
	"./spreadsheet/spreadsheet.js": "rHua",
	"./sql/sql.js": "JGZi",
	"./stex/stex.js": "1cvq",
	"./stylus/stylus.js": "yKVp",
	"./swift/swift.js": "uNyq",
	"./tcl/tcl.js": "F9rU",
	"./textile/textile.js": "NnLm",
	"./tiddlywiki/tiddlywiki.js": "ATIm",
	"./tiki/tiki.js": "HVZi",
	"./toml/toml.js": "mcQ8",
	"./tornado/tornado.js": "pjLr",
	"./troff/troff.js": "MrOV",
	"./ttcn-cfg/ttcn-cfg.js": "P/dt",
	"./ttcn/ttcn.js": "su+d",
	"./turtle/turtle.js": "hL2b",
	"./twig/twig.js": "RfqI",
	"./vb/vb.js": "DZXy",
	"./vbscript/vbscript.js": "Vyxb",
	"./velocity/velocity.js": "CdSB",
	"./verilog/verilog.js": "BgqI",
	"./vhdl/vhdl.js": "K/yg",
	"./vue/vue.js": "/9hD",
	"./webidl/webidl.js": "JfGf",
	"./xml/xml.js": "ezqs",
	"./xquery/xquery.js": "zGcu",
	"./yacas/yacas.js": "KXeR",
	"./yaml-frontmatter/yaml-frontmatter.js": "ybz3",
	"./yaml/yaml.js": "uqUb",
	"./z80/z80.js": "3Y8U"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ENpB";

/***/ }),

/***/ "EuIX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FhoZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {
// Template version: 1.1.3
// see http://vuejs-templates.github.io/webpack for documentation.

var path = __webpack_require__("o/zv");

module.exports = {
  env:  true ? __webpack_require__("rBKV") : require("./dev.env"),
  build: {
    env: __webpack_require__("rBKV"),
    index: path.resolve(__dirname, "../dist/index.html"),
    assetsRoot: path.resolve(__dirname, "../dist"),
    assetsSubDirectory: "static",
    assetsPublicPath: "/",
    productionSourceMap: true,
    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ["js", "css"],
    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: Object({"NODE_ENV":"production","BACKEND_URI":"https://longcode.herokuapp.com/"}).npm_config_report
  },
  dev: {
    env: __webpack_require__("dhIU"),
    port: Object({"NODE_ENV":"production","BACKEND_URI":"https://longcode.herokuapp.com/"}).PORT || 8080,
    autoOpenBrowser: true,
    assetsSubDirectory: "static",
    assetsPublicPath: "/",
    proxyTable: {},
    // CSS Sourcemaps off by default because relative paths are "buggy"
    // with this option, according to the CSS-Loader README
    // (https://github.com/webpack/css-loader#sourcemaps)
    // In our experience, they generally work as expected,
    // just be aware of this issue when enabling this option.
    cssSourceMap: false
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),

/***/ "GggT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IHZ5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//

var _vuex = __webpack_require__("NYxO");

exports.default = {
  name: 'body',
  data: function data() {
    return {
      routeChange: 'slide-left'
    };
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    var toDepth = to.path.split('/').length;
    var fromDepth = from.path.split('/').length;
    this.routeChange = toDepth < fromDepth ? 'slide-right' : 'slide-left';
    next();
  },

  computed: _extends({}, (0, _vuex.mapState)(['userAuth', 'userData'])),
  methods: _extends({}, (0, _vuex.mapMutations)(['auth']))
};

/***/ }),

/***/ "Ijt+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K00g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LDKD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LxZp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M1Ra":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vuex = __webpack_require__("NYxO");

var _firebase = __webpack_require__("Sazm");

var _firebase2 = _interopRequireDefault(_firebase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'index',
  data: function data() {
    return {
      signupEmail: null,
      signupPassword: null,
      signupRePassword: null,
      signinEmail: null,
      signinPassword: null
    };
  },

  computed: _extends({}, (0, _vuex.mapState)(['userAuth', 'userData', 'userCred'])),
  methods: _extends({}, (0, _vuex.mapMutations)(['fbLogin', 'gitLogin', 'logout']), {
    signIn: function signIn() {
      if (!this.userAuth) {
        _firebase2.default.auth().signInWithEmailAndPassword(this.signinEmail, this.signinPassword).then(function () {
          swal("Signed in", "คุณเข้าสู่ระบบด้วย email", "success");
        }).catch(function (error) {
          if (error.code == 'auth/wrong-password') {
            swal("SIGN IN", "รหัสผ่านไม่ถูกต้อง", "error");
          }
          console.log(error);
        });
      }
    },
    signUp: function signUp() {
      if (this.signupPassword != this.signupRePassword) {
        swal({ title: 'Password', text: 'กรุณายืนยันรหัสผ่านให้ถูกต้อง', icon: 'warning' });
        return false;
      }
      _firebase2.default.auth().createUserWithEmailAndPassword(this.signupEmail, this.signupPassword).then(function () {
        swal("SIGN UP.", "สมัครสมาชิกเสร็จสิ้น", "success");
      }).catch(function (error) {
        if (error.code == 'auth/email-already-in-use') {
          swal("SIGN UP", "อีเมลนี้ไม่สามารถใช้ได้", "error");
          return false;
        }
      });
    }
  })
};

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5a64124_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("cZPU");
function injectStyle (ssrContext) {
  __webpack_require__("Wz/M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5a64124_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MPNI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mpj/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__("M93x");

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__("YaEn");

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__("YtJ0");

var _store2 = _interopRequireDefault(_store);

var _veeValidate = __webpack_require__("sUu7");

var _veeValidate2 = _interopRequireDefault(_veeValidate);

var _vueCodemirror = __webpack_require__("f90G");

var _vueCodemirror2 = _interopRequireDefault(_vueCodemirror);

var _sweetalert = __webpack_require__("e7x4");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueCodemirror2.default); // The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

_vue2.default.use(_veeValidate2.default);
_vue2.default.config.productionTip = false;

/* eslint-disable no-new */
new _vue2.default({
  store: _store2.default,
  el: '#app',
  router: _router2.default,
  template: '<App/>',
  components: { App: _App2.default }
});

/***/ }),

/***/ "OZFz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OnXI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PLFC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("M1Ra");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0693f1ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("TwwJ");
function injectStyle (ssrContext) {
  __webpack_require__("jNgJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0693f1ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "PsxY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q6j7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qzi5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//

exports.default = {
    name: 'mytask'
};

/***/ }),

/***/ "R3s6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RGFY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vuex = __webpack_require__("NYxO");

exports.default = {
  name: 'admin',
  computed: _extends({}, (0, _vuex.mapState)(['userAuth', 'userData'])),
  methods: _extends({}, (0, _vuex.mapMutations)(['auth']))
};

/***/ }),

/***/ "T1b9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUser_vue__ = __webpack_require__("+g7E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUser_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUser_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUser_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUser_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_380eeb06_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUser_vue__ = __webpack_require__("8HjM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUser_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_380eeb06_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "T3rp":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "T6AU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vuex = __webpack_require__("NYxO");

exports.default = {
  name: 'header',
  mounted: function mounted() {
    $('.nav-link').on('click', function () {
      $('.navbar-collapse').collapse('hide');
    });
  },
  created: function created() {
    // console.log(this.userAuth)
  },

  computed: _extends({}, (0, _vuex.mapState)(['userAuth', 'userData'])),
  methods: _extends({}, (0, _vuex.mapMutations)(['logout', 'fbLogin', 'gitLogin']))
};

/***/ }),

/***/ "T8qm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TlOy":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "TwwJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userAuth && _vm.userData)?_c('div',[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"index-landing col-md-11 col-lg-9"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('router-link',{attrs:{"to":{name: 'practice'}}},[_c('div',{staticClass:"card card-practice"},[_c('div',{staticClass:"card-block"},[_c('div',{staticClass:"card-block-header card-block-practice-header"},[_vm._v("\n                  Practice\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-block-body card-block-practice-body"},[_vm._v("\n                  แหล่งรวมโจทย์เพื่อฝึกฝน\n                  "),_c('hr',{staticStyle:{"border-color":"#EAC67A"}}),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('strong',{staticClass:"btn"},[_vm._v("View")])])])])])])],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)])])])]):_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"index-login col-10 col-sm-8 col-md-6 col-lg-4"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"index-login-body"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.signIn($event)}}},[_c('div',{staticClass:"from-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signinEmail),expression:"signinEmail"}],staticClass:"form-contorl",attrs:{"type":"email","placeholder":"Email","required":""},domProps:{"value":(_vm.signinEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.signinEmail=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"from-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signinPassword),expression:"signinPassword"}],staticClass:"form-contorl",attrs:{"type":"password","placeholder":"Password","required":""},domProps:{"value":(_vm.signinPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.signinPassword=$event.target.value}}})]),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"login-icon-facebook",on:{"click":_vm.fbLogin}},[_vm._m(5)])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"login-icon-github",on:{"click":_vm.gitLogin}},[_vm._m(6)])])]),_vm._v(" "),_c('hr',{staticClass:"hr-sm"}),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('hr',{staticClass:"hr-sm"})])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"index-sign-up"}},[_c('div',{staticClass:"modal-dialog modal-sm",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{staticClass:"text-left",on:{"submit":function($event){$event.preventDefault();return _vm.signUp($event)}}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signupEmail),expression:"signupEmail"}],staticClass:"form-control",attrs:{"pattern":".{6,}","name":"taskName","type":"email","placeholder":"Email","required":""},domProps:{"value":(_vm.signupEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.signupEmail=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signupPassword),expression:"signupPassword"}],staticClass:"form-control",attrs:{"pattern":".{6,}","name":"taskName","type":"password","placeholder":"Password","required":""},domProps:{"value":(_vm.signupPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.signupPassword=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signupRePassword),expression:"signupRePassword"}],staticClass:"form-control",attrs:{"pattern":".{6,}","name":"taskName","type":"password","placeholder":"Retype password","required":""},domProps:{"value":(_vm.signupRePassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.signupRePassword=$event.target.value}}})]),_vm._v(" "),_vm._m(9)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-6 disabled"},[_c('div',{staticClass:"card card-challenges"},[_c('div',{staticClass:"card-block"},[_c('div',{staticClass:"card-block-header card-block-challenges-header"},[_vm._v("\n                Discuss\n              ")]),_vm._v(" "),_c('div',{staticClass:"card-block-body card-block-challenges-body"},[_vm._v("\n                ส่วนแลกเปลี่ยนความคิดหรือความคิดเห็น\n                "),_c('hr',{staticStyle:{"border-color":"#EAC67A"}}),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('strong',{staticClass:"btn"},[_vm._v("View")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-6 disabled"},[_c('div',{staticClass:"card card-tournaments"},[_c('div',{staticClass:"card-block"},[_c('div',{staticClass:"card-block-header card-block-tournaments-header"},[_vm._v("\n                Tournaments\n              ")]),_vm._v(" "),_c('div',{staticClass:"card-block-body card-block-tournaments-body"},[_vm._v("\n                เป็นอีเว้นที่ใครคิดว่าแน่ก็มาลองแข่งกันได้\n                "),_c('hr',{staticStyle:{"border-color":"#EAC67A"}}),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('strong',{staticClass:"btn"},[_vm._v("View")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-6 disabled"},[_c('div',{staticClass:"card card-arcade"},[_c('div',{staticClass:"card-block"},[_c('div',{staticClass:"card-block-header card-block-arcade-header"},[_vm._v("\n                Classroom\n              ")]),_vm._v(" "),_c('div',{staticClass:"card-block-body card-block-arcade-body"},[_vm._v("\n                สร้างห้องเรียนของตัวเอง\n                "),_c('hr',{staticStyle:{"border-color":"#EAC67A"}}),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('strong',{staticClass:"btn"},[_vm._v("View")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-login-header"},[_c('img',{attrs:{"src":__webpack_require__("aaIl")}}),_vm._v(" "),_c('div',{staticClass:"index-login-brand"},[_c('strong',[_vm._v("มา LONGCODE กัน")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-danger pointer bg-salmon-1",staticStyle:{"width":"100%"},attrs:{"type":"submit"}},[_vm._v("SIGN IN")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-facebook-square",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-github",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"pointer sign-up",attrs:{"data-toggle":"modal","data-target":"#index-sign-up","aria-expanded":"false","aria-controls":"#index-sign-up"}},[_vm._v("Create and Account")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLongTitle"}},[_c('strong',[_vm._v("SIGN UP")])]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button pointer","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{staticClass:"pointer",attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-danger pointer bg-salmon-1",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-plus",attrs:{"aria-hidden":"true"}}),_vm._v(" SIGN UP")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UM8r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UoAS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V3bd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tournaments_vue__ = __webpack_require__("v9wD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tournaments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tournaments_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tournaments_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tournaments_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61bb8832_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tournaments_vue__ = __webpack_require__("vujF");
function injectStyle (ssrContext) {
  __webpack_require__("olRj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tournaments_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61bb8832_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tournaments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "VTWD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vuex = __webpack_require__("NYxO");

var _firebase = __webpack_require__("Sazm");

var _firebase2 = _interopRequireDefault(_firebase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'practice',
  data: function data() {
    return {
      userEnroll: []
    };
  },

  computed: _extends({}, (0, _vuex.mapState)(['userAuth', 'userData', 'practiceList', 'taskPass'])),
  created: function created() {
    this.practiceLoad();
  },

  methods: {
    practiceLoad: function practiceLoad() {
      this.$store.commit('practiceLoad');
    }
  }
};

/***/ }),

/***/ "Wz/M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X1Ds":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XQDJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xdwu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y0SK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y7A8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YIvS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vuex = __webpack_require__("NYxO");

var _firebase = __webpack_require__("Sazm");

var _firebase2 = _interopRequireDefault(_firebase);

var _sweetalert = __webpack_require__("e7x4");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'adminTask',
  data: function data() {
    return {
      tasks: null,
      taskName: null,
      taskDetail: null,
      taskFunciton: null,
      taskInput: {},
      taskInputName: {},
      taskInputValue: {},
      taskOutput: {},
      testcase: 1,
      input: 1
    };
  },

  computed: _extends({}, (0, _vuex.mapState)(['userAuth', 'userCred'])),
  created: function created() {
    this.taskLoad();
  },

  methods: _extends({}, (0, _vuex.mapMutations)(['fbLogin', 'gitLogin', 'logout']), {
    addCase: function addCase() {
      if (this.testcase < 10) {
        this.testcase++;
      }
    },
    removeCase: function removeCase() {
      if (this.testcase > 1) {
        this.testcase--;
      }
    },
    addInput: function addInput() {
      if (this.input < 10) {
        this.input++;
      }
    },
    removeInput: function removeInput() {
      if (this.input > 1) {
        this.input--;
      }
    },
    taskLoad: function taskLoad() {
      var this_ = this;
      var allTask = [];
      // this_.tasks = null
      _firebase2.default.database().ref('tasks/').once('value', function (snapshot) {
        snapshot.forEach(function (currentTask) {
          var taskPush = currentTask.val();
          allTask.push(taskPush);
        });
        this_.tasks = allTask;
      });
    },
    taskRemove: function taskRemove(id) {
      var this_ = this;
      var allTask = [];
      // this.tasks = null
      (0, _sweetalert2.default)({
        title: 'Remove Task',
        text: 'คุณต้องการลบ Task นี้หรือไม่?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!'
      }).then(function (result) {
        if (result.value) {
          _firebase2.default.database().ref('/tasks').orderByChild('createdAt').equalTo(id).once('value').then(function (snapshot) {
            snapshot.forEach(function (childSnapshot) {
              _firebase2.default.database().ref('/tasks').child(childSnapshot.key).remove().then(function () {
                (0, _sweetalert2.default)("Remove Task", "คุณได้ลบ Task", "success");
                this_.taskLoad();
              });
            });
          });
        }
      });
    },
    taskAdd: function taskAdd() {
      var testcase = [];
      for (var x = 1; x < this.testcase + 1; x++) {
        // all testcase
        var allInput = [];
        for (var input in this.taskInputValue) {
          // all input
          var hashInput = input.split('-');
          var inputName = this.taskInputName[hashInput[1]];
          var dictInput = [];
          if (input.split('-')[0] == x) {
            // select input in this testcase.
            var y = 1;
            var inputValue = this.taskInputValue[input];
            // var inputName = this.taskInputName[y]
            var filterValue = [];
            y += 1;
            if (inputValue.startsWith('"') && inputValue.endsWith('"')) {
              inputValue = String(inputValue).replace(/['"]+/g, '');
            } else if (!isNaN(inputValue)) {
              inputValue = parseFloat(inputValue);
            } else {
              if (inputValue.startsWith('[') && inputValue.endsWith(']')) {
                inputValue = JSON.parse(inputValue);
              }
            }
            var inputValueList = [];
            inputValueList.push(inputValue);

            dictInput[inputName] = inputValueList;
            allInput.push(dictInput);
          }
        }
        testcase.push({ 'input': allInput, 'output': this.taskOutput[x] });
      }

      var taskKey = _firebase2.default.database().ref('users').push().key;
      var updates = {};

      var addTaskData = { // created data array
        'taskId': taskKey,
        'name': this.taskName,
        'detail': this.taskDetail,
        'testcase': testcase,
        'send': 1,
        'pass': 1,
        'functionName': this.taskFunciton,
        'createdAt': _firebase2.default.database.ServerValue.TIMESTAMP,
        'status': 'enable'
      };
      _firebase2.default.database().ref('/tasks/' + taskKey).set(addTaskData);
      (0, _sweetalert2.default)("Added", "เพิ่ม Task เข้าสู่ระบบ", "success");
      this.taskLoad(); //refresh task
      this.taskName = null, // remove all data
      this.taskDetail = null, this.testcase = 1, this.input = 1, this.taskInput = {}, this.taskOutput = {};
      this.taskInputName = {}, this.taskInputValue = {};
      $('#admin-task-add-modal').modal('hide');
    }
  })
};

/***/ }),

/***/ "YQZx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.userAuth && _vm.userData && _vm.userData.permission > 2)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"admin col-lg-9 col-md-11 col-sm-11 col-xs-11 mx-auto"},[_c('div',{staticClass:"admin-panel text-left"},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row text-center"},[_c('router-link',{staticClass:"col-md-6 mb-1",staticStyle:{"color":"#DFDCE3","text-decoration":"none"},attrs:{"to":{ name: 'adminUser'}}},[_c('div',{staticClass:"card admin-button",staticStyle:{"background":"#233237"}},[_c('div',{staticClass:"card-header"},[_c('strong',{staticStyle:{"text-decoration":"none"}},[_c('i',{staticClass:"fa fa-users",attrs:{"aria-hidden":"true"}}),_vm._v(" User Mangement")])])])]),_vm._v(" "),_c('router-link',{staticClass:"col-md-6 mb-1",staticStyle:{"color":"#233237","text-decoration":"none"},attrs:{"to":{ name: 'adminTask'}}},[_c('div',{staticClass:"card admin-button",staticStyle:{"background":"#EAC67A"}},[_c('div',{staticClass:"card-header"},[_c('strong',[_c('i',{staticClass:"fa fa-code",attrs:{"aria-hidden":"true"}}),_vm._v(" Task Mangement")])])])])],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"admin-manage text-left"},[_c('div',{staticClass:"admin-manage-box"},[_c('router-view')],1)])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('strong',{staticStyle:{"color":"#233237"}},[_vm._v("ADMIN PANEL")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _Body = __webpack_require__("bV+u");

var _Body2 = _interopRequireDefault(_Body);

var _Header = __webpack_require__("gd1P");

var _Header2 = _interopRequireDefault(_Header);

var _Index = __webpack_require__("PLFC");

var _Index2 = _interopRequireDefault(_Index);

var _Scoreboard = __webpack_require__("c309");

var _Scoreboard2 = _interopRequireDefault(_Scoreboard);

var _Mytask = __webpack_require__("r6YE");

var _Mytask2 = _interopRequireDefault(_Mytask);

var _vuex = __webpack_require__("NYxO");

var _firebase = __webpack_require__("Sazm");

var _firebase2 = _interopRequireDefault(_firebase);

var _Admin = __webpack_require__("gb+z");

var _Admin2 = _interopRequireDefault(_Admin);

var _AdminUser = __webpack_require__("T1b9");

var _AdminUser2 = _interopRequireDefault(_AdminUser);

var _AdminTask = __webpack_require__("tfqW");

var _AdminTask2 = _interopRequireDefault(_AdminTask);

var _Aracde = __webpack_require__("7+bd");

var _Aracde2 = _interopRequireDefault(_Aracde);

var _Challenges = __webpack_require__("D1hx");

var _Challenges2 = _interopRequireDefault(_Challenges);

var _Practice = __webpack_require__("pK3e");

var _Practice2 = _interopRequireDefault(_Practice);

var _Tournaments = __webpack_require__("V3bd");

var _Tournaments2 = _interopRequireDefault(_Tournaments);

var _PracticeTask = __webpack_require__("BEHr");

var _PracticeTask2 = _interopRequireDefault(_PracticeTask);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Admin
_vue2.default.use(_vueRouter2.default);

// Course


// Body


// Layout
// System

var router = new _vueRouter2.default({
  mode: 'history',
  routes: [{
    path: '/',
    components: {
      header: _Header2.default,
      body: _Body2.default
    },
    children: [{ path: '/', component: _Index2.default, name: 'index' }, { path: '/scoreboard', component: _Scoreboard2.default, name: 'scoreboard', meta: { requiresAuth: true } }, { path: '/mytask', component: _Mytask2.default, name: 'mytask', meta: { requiresAuth: true } }, { path: '/admin', component: _Admin2.default, name: 'admin', meta: { requiresAuth: true, requiresAdmin: true }, children: [{ path: 'user', component: _AdminUser2.default, name: 'adminUser', meta: { requiresAdmin: true } }, { path: 'task', component: _AdminTask2.default, name: 'adminTask', meta: { requiresAdmin: true } }]
    }, { path: '/practice', component: _Practice2.default, name: 'practice', meta: { requiresAuth: true } }, { path: '/practice/:taskId', component: _PracticeTask2.default, name: 'practiceTask', meta: { requiresAuth: true } }, { path: '/practice', component: _Challenges2.default, name: 'challenges', meta: { requiresAuth: true } }, { path: '/practice', component: _Tournaments2.default, name: 'tournaments', meta: { requiresAuth: true } }, { path: '/practice', component: _Aracde2.default, name: 'aracde', meta: { requiresAuth: true } }]
  }]
});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    _firebase2.default.auth().onAuthStateChanged(function (user) {
      if (user) {
        next();
      } else {
        next({ path: '/' });
      }
    });
  } else if (to.matched.some(function (record) {
    return record.meta.requiresAdmin;
  })) {
    _firebase2.default.auth().onAuthStateChanged(function (user) {
      if (user.permission > 2) {
        next();
      } else {
        next({ path: '/' });
      }
    });
  } else {
    next();
  }
});

// router.beforeEach((to, from, next) => {
//   mapMutations(['auth'])
//   next()
// })
exports.default = router;

/***/ }),

/***/ "Yklg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Yokd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YtJ0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__("NYxO");

var _vuex2 = _interopRequireDefault(_vuex);

var _firebase = __webpack_require__("Sazm");

var _firebase2 = _interopRequireDefault(_firebase);

var _firebaseConfig = __webpack_require__("/y1X");

var _sweetalert = __webpack_require__("e7x4");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);
_firebase2.default.initializeApp(_firebaseConfig.firebaseConfig);

// Tutorial
var state = {
  userAuth: null,
  userData: null,
  practiceList: null,
  loading: false,
  taskPass: []
};
var mutations = {
  loading: function loading(state, set) {
    state.loading = set;
  },

  // fetch user data
  userDataFetch: function userDataFetch() {
    _firebase2.default.database().ref("/users").orderByChild("email").equalTo(state.userAuth.email).once("value").then(function (snapshot) {
      for (var i in snapshot.val()) {
        state.userData = snapshot.val()[i];
      }
    });
  },

  // Firebase auth state
  auth: function auth(state) {
    _firebase2.default.auth().onAuthStateChanged(function (user) {
      if (user) {
        state.userAuth = user;
        _firebase2.default.database().ref("/users").orderByChild("email").equalTo(user.email).once("value").then(function (snapshot) {
          if (!snapshot.val()) {
            if (!user.photoURL) {
              user.photoURL = "https://applech2.com/wp-content/uploads/2017/10/macOS-Guest-user-logo-icon.jpg";
            }
            if (!user.displayName) {
              user.displayName = user.email;
            }
            // Create user data in firebase
            var userKey = _firebase2.default.database().ref("users").push().key;
            var updates = {};
            var userData = {
              name: user.displayName,
              email: user.email,
              image: user.photoURL,
              uid: user.uid,
              authId: userKey,
              point: 0,
              permission: 1,
              createdAt: _firebase2.default.database.ServerValue.TIMESTAMP
            };
            updates["/users/" + userKey] = userData;
            _firebase2.default.database().ref().update(updates);

            // firebase.database().ref('/users').push(userData)
            _firebase2.default.database().ref("/users").orderByChild("email").equalTo(user.email).once("value").then(function (snapshot) {
              for (var i in snapshot.val()) {
                state.userData = snapshot.val()[i];
              }
            });
          } else {
            for (var i in snapshot.val()) {
              state.userData = snapshot.val()[i];
              // Get user tasks finish
              if (state.userData != undefined) {
                var userEnroll = state.userData.enroll;
                for (var i in userEnroll) {
                  for (var x in userEnroll[i]) {
                    if (userEnroll[i][x].status == "finish") {
                      state.taskPass.push(x);
                    }
                  }
                }
              }
            }
          }
        });
      }
    });
  },
  fbLogin: function fbLogin(state) {
    console.log(state);
    _firebase2.default.auth().setPersistence(_firebase2.default.auth.Auth.Persistence.SESSION).then(function () {
      var provider = new _firebase2.default.auth.FacebookAuthProvider();
      return _firebase2.default.auth().signInWithPopup(provider).then(function () {
        (0, _sweetalert2.default)("Signed in", "คุณเข้าสู่ระบบด้วยบัญชี facebook", "success");
      });
    }).catch(function (error) {
      console.log(error);
      _firebase2.default.auth().fetchProvidersForEmail(error.email).then(function (providers) {
        if (providers == "github.com") {
          (0, _sweetalert2.default)("Login failed.", "กรุณาเข้าสู่ระบบด้วยบัญชี github", "error");
        }
      });
    });
  },
  gitLogin: function gitLogin(state) {
    if (!state.userAuth) {
      _firebase2.default.auth().setPersistence(_firebase2.default.auth.Auth.Persistence.SESSION).then(function () {
        var provider = new _firebase2.default.auth.GithubAuthProvider();
        return _firebase2.default.auth().signInWithPopup(provider).then(function () {
          (0, _sweetalert2.default)("Signed in", "คุณเข้าสู่ระบบด้วยบัญชี github", "success");
        });
      }).catch(function (error) {
        _firebase2.default.auth().fetchProvidersForEmail(error.email).then(function (providers) {
          if (providers == "facebook.com") {
            (0, _sweetalert2.default)("Login failed", "กรุณาเข้าสู่ระบบด้วยบัญชี facebook", "error");
          }
        });
      });
    }
  },
  logout: function logout(state) {
    if (state.userAuth) {
      _firebase2.default.auth().signOut().then(function () {
        (0, _sweetalert2.default)("Logged out", "คุณได้ออกจากระบบแล้ว", "info");
      }).catch(function (error) {
        console.log(error);
      });
      state.userAuth = null;
      state.userData = null;
    }
  },
  practiceLoad: function practiceLoad(state) {
    _firebase2.default.database().ref("/tasks").orderByChild("createdAt").once("value").then(function (snapshot) {
      state.practiceList = snapshot.val();
    });
  }
};

var store = new _vuex2.default.Store({
  state: state,
  mutations: mutations
});

exports.default = store;

/***/ }),

/***/ "ZrWO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aHkt":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./3024-day.css": "tPrY",
	"./3024-night.css": "UoAS",
	"./abcdef.css": "9ozf",
	"./ambiance-mobile.css": "ZrWO",
	"./ambiance.css": "vX90",
	"./ayu-dark.css": "Yklg",
	"./ayu-mirage.css": "sRvP",
	"./base16-dark.css": "jGSh",
	"./base16-light.css": "x15G",
	"./bespin.css": "R3s6",
	"./blackboard.css": "kSL7",
	"./cobalt.css": "t9xi",
	"./colorforth.css": "Q6j7",
	"./darcula.css": "iVNi",
	"./dracula.css": "8sUU",
	"./duotone-dark.css": "n+LN",
	"./duotone-light.css": "GggT",
	"./eclipse.css": "hD67",
	"./elegant.css": "2b9r",
	"./erlang-dark.css": "XQDJ",
	"./gruvbox-dark.css": "iMM3",
	"./hopscotch.css": "opVC",
	"./icecoder.css": "scuT",
	"./idea.css": "spg9",
	"./isotope.css": "u3n7",
	"./lesser-dark.css": "LDKD",
	"./liquibyte.css": "fXer",
	"./lucario.css": "AnfX",
	"./material-darker.css": "OnXI",
	"./material-ocean.css": "o60K",
	"./material-palenight.css": "keo4",
	"./material.css": "epNC",
	"./mbo.css": "1XTk",
	"./mdn-like.css": "vsRU",
	"./midnight.css": "zLDg",
	"./monokai.css": "UM8r",
	"./moxer.css": "m5h3",
	"./neat.css": "Ijt+",
	"./neo.css": "bF3y",
	"./night.css": "ncdg",
	"./nord.css": "rhKk",
	"./oceanic-next.css": "CIEy",
	"./panda-syntax.css": "mBIq",
	"./paraiso-dark.css": "BR0Y",
	"./paraiso-light.css": "Y0SK",
	"./pastel-on-dark.css": "v/ec",
	"./railscasts.css": "zUoc",
	"./rubyblue.css": "0tbE",
	"./seti.css": "jykA",
	"./shadowfox.css": "cnpD",
	"./solarized.css": "Xdwu",
	"./ssms.css": "EuIX",
	"./the-matrix.css": "K00g",
	"./tomorrow-night-bright.css": "MPNI",
	"./tomorrow-night-eighties.css": "+bOk",
	"./ttcn.css": "+fg7",
	"./twilight.css": "Y7A8",
	"./vibrant-ink.css": "w/Cc",
	"./xq-dark.css": "qyuG",
	"./xq-light.css": "gSgD",
	"./yeti.css": "X1Ds",
	"./yonce.css": "uyU5",
	"./zenburn.css": "Mpj/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aHkt";

/***/ }),

/***/ "aaIl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/brand.e459245.png";

/***/ }),

/***/ "bF3y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bV+u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Body_vue__ = __webpack_require__("IHZ5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Body_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Body_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Body_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Body_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32de8e0c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Body_vue__ = __webpack_require__("lMlZ");
function injectStyle (ssrContext) {
  __webpack_require__("kkiD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Body_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32de8e0c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Body_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "c309":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scoreboard_vue__ = __webpack_require__("zjmh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scoreboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scoreboard_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scoreboard_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scoreboard_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d89c09c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scoreboard_vue__ = __webpack_require__("7nVR");
function injectStyle (ssrContext) {
  __webpack_require__("d1pw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scoreboard_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d89c09c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scoreboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "cZPU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"loading-transition"}},[_c('div',[_c('router-view',{attrs:{"name":"header"}}),_vm._v(" "),_c('router-view',{attrs:{"name":"body"}})],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"loading-transition"}},[((_vm.userAuth && !_vm.userData) || (_vm.userAuth && _vm.loading))?_c('div',{staticClass:"page-loading"},[_c('div',{staticClass:"page-loading-fade"}),_vm._v(" "),_c('div',{staticClass:"page-loading-icon"},[_c('img',{attrs:{"src":__webpack_require__("T3rp")}})]),_vm._v(" "),_c('div',{staticClass:"page-loading-spiner"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw"}),_c('br')]),_vm._v(" "),_c('div',{staticClass:"page-loading-label"},[_vm._v("\n        Loading...\n      ")])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cnpD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d1pw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dhIU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var merge = __webpack_require__("2cg0");
var prodEnv = __webpack_require__("rBKV");

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"',
  BACKEND_URI: "http://localhost:5000"
});

/***/ }),

/***/ "epNC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fViY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("Challenges")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fXer":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gMtO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//

exports.default = {};

/***/ }),

/***/ "gSgD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gb+z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Admin_vue__ = __webpack_require__("RGFY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Admin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Admin_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Admin_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Admin_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26d1cc7b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Admin_vue__ = __webpack_require__("YQZx");
function injectStyle (ssrContext) {
  __webpack_require__("BCHN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Admin_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26d1cc7b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Admin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "gd1P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("T6AU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e469d04_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("/g2R");
function injectStyle (ssrContext) {
  __webpack_require__("r+ve")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e469d04_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "hD67":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iI97":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iMM3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iVNi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jGSh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jNgJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jykA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kSL7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "keo4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kkiD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l1ch":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lMlZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('transition',{attrs:{"name":_vm.routeChange}},[_c('router-view',{staticClass:"child-view"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m5h3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mBIq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n+LN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ncdg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o60K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oabq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _vuex = __webpack_require__("NYxO");

var _firebase = __webpack_require__("Sazm");

var _firebase2 = _interopRequireDefault(_firebase);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _sweetalert = __webpack_require__("e7x4");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

var _index = __webpack_require__("FhoZ");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// require active-line.js
__webpack_require__("aGTD");
// styleSelectedText
__webpack_require__("U80t");
__webpack_require__("c+I8");
// hint
__webpack_require__("jQeI");
__webpack_require__("PsxY");
__webpack_require__("Mixr");
__webpack_require__("aGTD");
// highlightSelectionMatches
__webpack_require__("QSKu");
__webpack_require__("/A6h");
__webpack_require__("c+I8");
__webpack_require__("OkRY");
// keyMap
__webpack_require__("6S2o");
__webpack_require__("vq+x");
__webpack_require__("Z6qg");
__webpack_require__("RkhK");
__webpack_require__("LxZp");
__webpack_require__("c+I8");
__webpack_require__("CK2l");
__webpack_require__("7Xsf");
// foldGutter
__webpack_require__("Yokd");
__webpack_require__("fo6W");
__webpack_require__("soCA");
__webpack_require__("THjC");
__webpack_require__("Kk9m");
__webpack_require__("U3HU");
__webpack_require__("dxBS");
__webpack_require__("TQy8");

__webpack_require__("6S2o");
__webpack_require__("vq+x");
__webpack_require__("Z6qg");
__webpack_require__("RkhK");
__webpack_require__("LxZp");
__webpack_require__("c+I8");
__webpack_require__("CK2l");
__webpack_require__("tjx/");

exports.default = {
  name: "practiceTask",
  data: function data() {
    return {
      currentEnrollX: null,
      currentEnrollI: null,
      taskId: this.$route.params.taskId,
      taskData: null,
      taskLength: 0,
      functionName: null,
      argName: null,
      fail: null,
      point: 60,
      difficulty: "easy",
      code: "hi",
      editorOption: {
        tabSize: 4,
        indentWithTabs: true,
        indentUnit: 4,
        styleActiveLine: false,
        lineNumbers: false,
        line: true,
        foldGutter: true,
        styleSelectedText: true,
        gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
        highlightSelectionMatches: { showToken: /\w/, annotateScrollbar: true },
        mode: "text/x-python",
        hintOptions: {
          completeSingle: false
        },
        matchBrackets: true,
        showCursorWhenSelecting: true,
        theme: "hopscotch",
        autoCloseBrackets: true,
        extraKeys: { Ctrl: "autocomplete" },
        keyMap: "sublime"
      }
    };
  },

  computed: _extends({}, (0, _vuex.mapState)(["practiceList", "userAuth", "userData"])),
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.editorOption.lineNumbers = true;
      _this.editorOption.styleActiveLine = true;
    }, 3000);
  },
  created: function created() {
    this.taskLoad();
  },
  updated: function updated() {
    this.screenFull();
  },

  methods: _extends({}, (0, _vuex.mapMutations)(["userDataFetch", "loading", "auth"]), {
    taskLoad: function taskLoad() {
      var this_ = this;
      _firebase2.default.database().ref("/tasks").orderByChild("createdAt").equalTo(parseInt(this.taskId)).once("value").then(function (snapshot) {
        for (var i in snapshot.val()) {
          this_.taskData = snapshot.val()[i];
          this_.taskLength = snapshot.val()[i].testcase.length;
          var testcase = this_.taskData.testcase[0].input;
          var functionName = this_.taskData.functionName;
          var func = [];
          var argName = [];
          var argValue = [];
          for (var y in testcase) {
            for (var x in testcase[y]) {
              argName.push(x);
            }
          }
          this_.functionName = functionName;
          this_.argName = argName;
          func.push("def " + functionName + " (" + argName.join(", ") + "):\n\t#your code here");
          this_.code = func.join("\n\n\n");

          // Created point
          this_.point = Math.round(this_.taskData.send / this_.taskData.pass * 60 / 10) * 10;
          if (!this_.point) {
            this_.point = 100;
          }

          // Created difficulty
          var percent = Math.round(this_.taskData.pass * 100 / this_.taskData.send);
          if (percent > 90 || !percent) {
            var difficulty = "No data";
          } else if (percent < 90 && percent >= 70) {
            var difficulty = "Easy";
          } else if (percent < 70 && percent >= 50) {
            var difficulty = "Normal";
          } else if (percent < 50 && percent >= 30) {
            var difficulty = "Hard";
          } else {
            var difficulty = "Very Hard";
          }
          this_.difficulty = difficulty;
        }
      });
    },
    screenFull: function screenFull() {
      $(window).on("resize", function () {
        var screenHeight = $(window).height();
        var navbarHeight = $(".navbar").height();
        var fullHeight = screenHeight - navbarHeight;
        var halfHeight = fullHeight / 2;
        $(".practiceTask").css("min-height", fullHeight + "px");
        $(".code-container, .detail-body").css("min-height", fullHeight - $(".code-nav").height() + "px");
        var screenWidth = $(window).width();
        if (screenWidth <= 992 && screenWidth >= 767) {
          $(".practiceTask").css("margin-top", "-30px");
        } else {
          $(".practiceTask").css("margin-top", "-21px");
        }
      });
      var screenHeight = $(window).height();
      var navbarHeight = $(".navbar").height();
      var fullHeight = screenHeight - navbarHeight;
      var halfHeight = fullHeight / 2;
      $(".practiceTask").css("min-height", fullHeight + "px");
      $(".code-container, .detail-body").css("min-height", fullHeight - $(".code-nav").height() + "px");
      var screenWidth = $(window).width();
      if (screenWidth <= 992 && screenWidth >= 767) {
        $(".practiceTask").css("margin-top", "-30px");
      } else {
        $(".practiceTask").css("margin-top", "-21px");
      }
    },
    taskSubmit: function taskSubmit() {
      var _this2 = this;

      // Default
      var this_ = this;

      // Add this task in user data
      var query = "/users/" + this_.userData.authId;
      var updates = {};
      var taskUpdate = {};
      taskUpdate[this_.taskId] = { status: "doing" };
      updates[query + "/enroll"] = [taskUpdate];
      _firebase2.default.database().ref(query).once("value").then(function (snapshot) {
        // never been
        if (!snapshot.val().enroll) {
          _firebase2.default.database().ref().update(updates);
          // task increase send
          var taskSend = _firebase2.default.database().ref("tasks/" + this_.taskData.taskId + "/send");
          taskSend.transaction(function (send) {
            return send + 1;
          });
        } else {
          var enroll = snapshot.val().enroll;
          var enrollFound = true;

          // check current task is in user enroll
          for (var i in enroll) {
            for (var x in enroll[i]) {
              if (x == this_.taskId) {
                enrollFound = false;
              }
            }
          }

          if (enrollFound) {
            // user enroll
            var newEnroll = [];
            newEnroll = newEnroll.concat(snapshot.val().enroll).concat(taskUpdate);
            _firebase2.default.database().ref(query + "/enroll").set(newEnroll);

            // task increase send
            var taskSend = _firebase2.default.database().ref("tasks/" + this_.taskData.taskId + "/send");
            taskSend.transaction(function (send) {
              return send + 1;
            });
          }
        }
      });

      this_.userDataFetch();
      var userCode = this.code;
      var taskData = this.taskData;
      var crossData = { userCode: userCode, taskData: taskData };
      // console.log(JSON.stringify(crossData))

      // Request data from python server
      var path =  true ? "https://longcode.herokuapp.com/" : 'http://localhost:5000';
      // Load loading animate
      this.loading(true);

      _axios2.default.post(path, crossData).then(function (response) {
        // Close loading animate
        _this2.loading(false);
        var caseSet = [];
        var found = true;
        var pass = true;
        for (var i in response.data) {
          var currentData = response.data[i];
          if (currentData instanceof Array) {
            var caseName = "Case" + (currentData[0] + 1) + ": ";

            // SyntaxError
            if (currentData[1] == -2) {
              caseSet.push(caseName + ('<span style="color:orange">' + currentData[2] + "</span>"));
              pass &= false;
            } else {
              var re = currentData[1];
              pass &= re == 1 ? true : re == 0 ? false : false;
              caseSet.push(caseName + (re == 1 ? '<span style="color:green">Pass</span>' : re == 0 ? '<span style="color:red">Wrong</span><br><span>Your Answer: ' + currentData[2] + " </span>" : '<span style="color:red">Timeout</span>'));
            }

            // Code not found
          } else {
            found = false;
          }
        }
        if (found) {
          (0, _sweetalert2.default)({
            title: "Task",
            type: pass ? "success" : "warning",
            html: caseSet.join("<br>")
          }).then(function () {
            if (pass) {
              var userTaskCheck = true;
              var userEnroll = this_.userData.enroll;
              for (var i in userEnroll) {
                for (var x in userEnroll[i]) {
                  if (x == this_.taskId) {
                    for (var z in userEnroll[i][x]) {
                      if (userEnroll[i][x][z] == "finish") {
                        userTaskCheck = false;
                      }
                    }
                  }
                }
              }
              if (userTaskCheck) {
                (0, _sweetalert2.default)({
                  title: "Reward",
                  imageUrl: "https://grabkeys.net/storage/images/longcode/point.png",
                  html: "<h3>" + this_.point + "</h3>"
                }).then(function () {
                  var userEnroll = this_.userData.enroll;
                  var currentEnrollX = null;
                  var currentEnrollI = null;
                  for (var i in userEnroll) {
                    for (var x in userEnroll[i]) {
                      if (x == this_.taskId) {
                        currentEnrollX = x;
                        currentEnrollI = i;
                      }
                    }
                  }
                  // update user enroll status
                  var enrollStatusQuery = "users/" + this_.userData.authId + "/enroll/" + currentEnrollI + "/" + currentEnrollX + "/status";
                  var enrollStatus = _firebase2.default.database().ref(enrollStatusQuery);
                  enrollStatus.transaction(function (status) {
                    return "finish";
                  });

                  // update task enroll pass
                  var taskPass = _firebase2.default.database().ref("tasks/" + this_.taskData.taskId + "/pass");
                  taskPass.transaction(function (pass) {
                    return pass + 1;
                  });
                  // update user point
                  var userPoint = _firebase2.default.database().ref("users/" + this_.userData.authId + "/point");
                  userPoint.transaction(function (point) {
                    return point + this_.point;
                  });
                  this_.userDataFetch();
                  this_.auth();
                });
              } else {
                (0, _sweetalert2.default)({
                  title: "Redo",
                  html: "คุณจะไม่ได้คะแนน เรื่องจากคุณทำข้อนี้ไป",
                  type: "warning"
                });
              }
            }
          });
        } else {
          (0, _sweetalert2.default)({
            title: "Task",
            type: "error",
            html: "Code not found"
          });
        }
        if (pass) {
          // Update t
        }
      }).catch(function (error) {
        console.log("Error -> " + error);
      });
    }
  })
};

/***/ }),

/***/ "olRj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "opVC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pK3e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Practice_vue__ = __webpack_require__("VTWD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Practice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Practice_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Practice_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Practice_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c672cdc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Practice_vue__ = __webpack_require__("0n/o");
function injectStyle (ssrContext) {
  __webpack_require__("vRy4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Practice_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c672cdc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Practice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pgdX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//

exports.default = {};

/***/ }),

/***/ "qyuG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r+ve":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r6YE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mytask_vue__ = __webpack_require__("Qzi5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mytask_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mytask_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mytask_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mytask_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07f6201d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mytask_vue__ = __webpack_require__("8sIG");
function injectStyle (ssrContext) {
  __webpack_require__("tWFr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mytask_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07f6201d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mytask_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "rBKV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  NODE_ENV: '"production"',
  BACKEND_URI: JSON.stringify("https://longcode.herokuapp.com/")
};

/***/ }),

/***/ "rhKk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sRvP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "scuT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "spg9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t9xi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tPrY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tWFr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tfqW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminTask_vue__ = __webpack_require__("YIvS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminTask_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminTask_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminTask_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminTask_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_959a131c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminTask_vue__ = __webpack_require__("yMTe");
function injectStyle (ssrContext) {
  __webpack_require__("OZFz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminTask_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_959a131c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminTask_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "twqq":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "u3n7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uyU5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v/ec":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v9wD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//

exports.default = {};

/***/ }),

/***/ "vRy4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vX90":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vsRU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vujF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("Tournament")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w/Cc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x15G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vuex = __webpack_require__("NYxO");

exports.default = {
  name: 'app',
  computed: _extends({}, (0, _vuex.mapState)(['userAuth', 'userData', 'loading'])),
  created: function created() {
    // Auth autoload
    this.authLoad();
  },

  methods: {
    authLoad: function authLoad() {
      this.$store.commit('auth');
    }
  }
};

/***/ }),

/***/ "yMTe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-task"},[_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"admin-task-add-modal","tabindex":"-1","role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"border-radius":"3px"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.taskAdd($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"taskAddForm"}},[_vm._v("Task name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.taskName),expression:"taskName"}],staticClass:"form-control",attrs:{"name":"taskName","type":"text","required":""},domProps:{"value":(_vm.taskName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.taskName=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Description")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.taskDetail),expression:"taskDetail"}],staticClass:"form-control",attrs:{"name":"taskDetail","rows":"3","required":""},domProps:{"value":(_vm.taskDetail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.taskDetail=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Function Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.taskFunciton),expression:"taskFunciton"}],staticClass:"form-control",attrs:{"name":"taskFunction","type":"text","required":""},domProps:{"value":(_vm.taskFunciton)},on:{"input":function($event){if($event.target.composing){ return; }_vm.taskFunciton=$event.target.value}}})]),_vm._v(" "),_c('hr',{staticClass:"hr-sm"}),_vm._v(" "),_c('div',{staticClass:"mb-2"},[_c('strong',{staticClass:"pointer salmon-1",staticStyle:{"font-size":"15px"},on:{"click":_vm.addCase}},[_c('i',{staticClass:"fa fa-plus",attrs:{"aria-hidden":"true"}}),_vm._v(" ADD TESTCASE")])]),_vm._v(" "),_vm._l((_vm.testcase),function(count){return _c('div',{staticClass:"add-testcase"},[_c('div',{staticClass:"add-testcase-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_vm._v("\n                    CASE "+_vm._s(count)+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"col text-right"},[(count != 1)?_c('i',{staticClass:"fa fa-times btn-delete",staticStyle:{"font-size":"18px"},attrs:{"aria-hidden":"true"},on:{"click":_vm.removeCase}}):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"add-testcase-body pt-1"},[_vm._l((_vm.input),function(currentInput){return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"mb-2",staticStyle:{"box-shadow":"0 2px 0 0 #D94B3F"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('label',{staticClass:"m-0"},[_vm._v("Input"+_vm._s(currentInput))])]),_vm._v(" "),_c('div',{staticClass:"col text-right"},[(currentInput != 1)?_c('i',{staticClass:"fa fa-trash salmon-1 pointer",attrs:{"aria-hidden":"true"},on:{"click":_vm.removeInput}}):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.taskInputName[currentInput]),expression:"taskInputName[currentInput]"}],staticClass:"form-control",attrs:{"placeholder":"input name","required":""},domProps:{"value":(_vm.taskInputName[currentInput])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.taskInputName, currentInput, $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.taskInputValue[count +'-'+ currentInput]),expression:"taskInputValue[count +'-'+ currentInput]"}],staticClass:"form-control",attrs:{"placeholder":"value","required":""},domProps:{"value":(_vm.taskInputValue[count +'-'+ currentInput])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.taskInputValue, count +'-'+ currentInput, $event.target.value)}}})])])]),_vm._v(" "),_c('hr',{staticClass:"hr-sm"})])])}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center pointer",on:{"click":_vm.addInput}},[_vm._m(2,true)])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Output")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.taskOutput[count]),expression:"taskOutput[count]"}],staticClass:"form-control",attrs:{"name":"taskOutput","type":"text","required":""},domProps:{"value":(_vm.taskOutput[count])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.taskOutput, count, $event.target.value)}}})])])])],2)])}),_vm._v(" "),_c('hr',{staticClass:"hr-sm"}),_vm._v(" "),_vm._m(3)],2)])])])]),_vm._v(" "),_c('table',{staticClass:"table",staticStyle:{"clear":"both"}},[_vm._m(4),_vm._v(" "),_c('tbody',_vm._l((_vm.tasks),function(task,num){return _c('tr',[_c('td',{attrs:{"width":"10%"}},[_vm._v(_vm._s(num+1))]),_vm._v(" "),_c('td',{staticStyle:{"cursor":"pointer"},attrs:{"width":"75%","data-toggle":"collapse","data-target":'#' + task.createdAt,"aria-expanded":"false","aria-controls":"#admin-task-view"}},[_c('div',[_c('strong',[_vm._v(_vm._s(task.name))])]),_vm._v(" "),_c('div',{staticClass:"collapse",attrs:{"id":task.createdAt}},[_c('div',{staticClass:"fa-1x mt-1",staticStyle:{"color":"#595959"}},[_vm._v(_vm._s(task.detail))]),_vm._v(" "),_c('hr',{staticStyle:{"border":"0.5px solid #ccc","margin":"10px 0"}}),_vm._v(" "),_vm._l((task.testcase),function(currentCase,numCase){return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"card card-header view-testcase-header"},[_vm._v("Case "+_vm._s(numCase))]),_vm._v(" "),_c('div',{staticClass:"view-testcase-body"},[_c('div',[_vm._v("                 \n                    Input:\n                    "),_vm._l((currentCase.input),function(currentInput){return _c('div',[_vm._v("\n                      "+_vm._s(currentInput)+"\n                    ")])}),_vm._v(" "),_c('hr',{staticClass:"hr-sm"}),_vm._v("\n                    Output: "+_vm._s(currentCase.output)+" "),_c('br'),_c('br')],2)])])])})],2)]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"width":"15%"}},[_c('a',{staticStyle:{"color":"#D94B3F","cursor":"pointer"},on:{"click":function($event){return _vm.taskRemove(task.createdAt)}}},[_c('i',{staticClass:"fa fa-2x fa-times",attrs:{"aria-hidden":"true"}})])])])}),0)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('br')])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-sm btn-danger pointer mb-3 bg-salmon-1",attrs:{"type":"button","data-toggle":"modal","data-target":"#admin-task-add-modal"}},[_c('i',{staticClass:"fa fa-plus",attrs:{"aria-hidden":"true"}}),_vm._v(" ADD TASK")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLongTitle"}},[_c('strong',{staticStyle:{"color":"#D94B3F"}},[_vm._v("ADD TASK")])]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button pointer","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{staticClass:"pointer",attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"5px 10px","border":"1px dashed #D94B3F","border-radius":"3px"}},[_c('strong',{staticClass:"salmon-2"},[_vm._v("ADD INPUT")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn-lg btn-danger pointer bg-salmon-1",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-plus",attrs:{"aria-hidden":"true"}}),_vm._v(" ADD TASK")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"width":"10%"}},[_vm._v("#")]),_vm._v(" "),_c('th',{attrs:{"width":"75%"}},[_vm._v("NAME")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("DELETE")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zLDg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zUoc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zjmh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vuex = __webpack_require__("NYxO");

var _firebase = __webpack_require__("Sazm");

var _firebase2 = _interopRequireDefault(_firebase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'scoreboard',
    data: function data() {
        return {
            scoreBest: []
        };
    },

    computed: _extends({}, (0, _vuex.mapState)(['userAuth', 'userData'])),
    created: function created() {
        this.scoreboardBest();
    },

    methods: {
        scoreboardBest: function scoreboardBest() {
            var this_ = this;
            var allScore = [];
            _firebase2.default.database().ref('users/').orderByChild('point').limitToLast(30).on('value', function (snapshot, error) {
                snapshot.forEach(function (resScore) {
                    var score = resScore.val();
                    allScore.push(score);
                });
                this_.scoreBest = allScore.reverse();
            });
        }
    }
};

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.4de2bb107f2ec4951b56.js